// extracted by mini-css-extract-plugin
export default {"container":"EmailPreviewView_container__DpkkQ","label":"EmailPreviewView_label__K0cOv","divider":"EmailPreviewView_divider__33nNb","body":"EmailPreviewView_body__EWHRU"};